export default __webpack_public_path__ + "static/media/Mask Group2.1934c769.png";